function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDietNutrition = function SvgDietNutrition(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "%100",
    height: "%100",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M12 8.625c.439-.425.917-.897 1.5-1.132a5.3 5.3 0 0 1 1.871-.368c2.48 0 5.608 2.047 4.117 5.932l-2.587 5.563c-.471.922-1.105 1.255-1.767 1.255-1.199 0-2.551-1.062-3.134-1.062-.587 0-1.937 1.062-3.132 1.049-.665 0-1.299-.336-1.77-1.255l-2.588-5.55C3.024 9.172 6.148 7.125 8.627 7.125a5.3 5.3 0 0 1 1.873.368c.576.235 1.07.707 1.5 1.132Zm0 0V3m3.581.424a3.1 3.1 0 0 0-1.118.707c-.296.3-.498.651-.588 1.024a3.8 3.8 0 0 0 1.39.282c.485.008.966-.073 1.403-.236a3.1 3.1 0 0 0 1.117-.705c.296-.3.498-.649.59-1.02a3.8 3.8 0 0 0-1.389-.288 3.8 3.8 0 0 0-1.405.236Z"
  }));
};
export default SvgDietNutrition;